import GLightbox from 'glightbox';

export default function products() {
	const lightbox = GLightbox({
		selector: '.woocommerce-product-gallery__image > a',
	});
	// This function is responsible for updating the order quantity
	const updateQuantity = () => {
		$('.product-card .qty').on('change', function () {
			const quantity = $(this).val();
			const $button = $(this)
				.closest('.product-card')
				.find('a.add_to_cart_button');
			const buttonID = $button.data('product_id');
			if (buttonID && quantity) {
				// For AJAX add-to-cart actions
				$button.attr('data-quantity', quantity);
				// For non-AJAX add-to-cart actions
				$button.attr(
					'href',
					'?add-to-cart=' + buttonID + '&quantity=' + quantity
				);
			}
		});
	};
	updateQuantity();
}
